import { useState } from "react";
import {
  Outlet,
  useNavigate,
  useParams,
} from "react-router-dom";


// styles and images
import "../project/Project.css";
import Download from "../../assets/download.svg";
import Mail from "../../assets/mail.svg";
import BlackDislike from "../../assets/black-dislike.png";
import BlackLike from "../../assets/black-like.png";
import DollarSign from "../../assets/dollar_sign.svg";
import Trash from "../../assets/delete.svg";
import Add from "../../assets/add_circle.svg";

// global
import { accountDataStore, projectStore, userStore } from "../../store/Store";

// components
import Dates from "../../components/Dates";

// hooks
import useDownloadProjectInvoice from "../../hooks/useDownloadProjectInvoice";

export default function InvoiceListRows({
  setUpdateTrigger,
  isAsset,
  setBody,
  invoices,
  setDeleteTrigger,
  setDeleteId,
  setAdjustmentTrigger,
  setFscMethodTrigger,
  fscMethod,
  fscMethodTrigger,
}) {
  // global
  const currentProject = projectStore((data) => data.currentProject);
  const projectCustomerInvoiceTotals = projectStore(
    (data) => data.projectCustomerInvoiceTotals,
  );
  const currentUser = userStore((data) => data.currentUser);
  const invoiceAdjustments = accountDataStore(
    (data) => data.invoiceAdjustments,
  );
  const projectSandRates = projectStore((data) => data.projectSandRates);

  // local
  // const [customerRateSheet, setCustomerRateSheet] = useState();
  const [downloadPending, setDownloadPending] = useState(false);
  const [invoiceForDownload, setInvoiceForDownload] = useState()
  const navigate = useNavigate();
  const { id } = useParams("id");

  // const { isPending, error } = useGetFetch(
  //   `${process.env.REACT_APP_BACKEND}/pc/rate-sheet/${currentProject.project.customer_rates_id}`,
  //   setCustomerRateSheet,
  // );

  const handleStatus = (s, invoice) => {
    if (s === "Trash") {
      setDeleteTrigger(true);
      setDeleteId(invoice.id);
    } else {
      setBody({
        id: invoice.id,
        invoice_name: invoice.invoice_name,
        invoice_status: s,
        is_asset: invoice.is_asset,
        updated_by_id: currentUser.id,
      });
      setUpdateTrigger(true);
    }
  };

  const getInvoiceAction = (invoice) => {
    switch (invoice.invoice_status_id) {
      case 25:
        return (
          <img
            className="account-invoice-action"
            src={Mail}
            alt="mail"
            onClick={() => handleStatus(21, invoice)}
          />
        );
      case 21:
        return (
          <>
            <img
              className="account-invoice-action"
              style={{ margin: "0 10px 0 0" }}
              src={BlackLike}
              alt="black-like"
              onClick={() => handleStatus(23, invoice)}
            />{" "}
            <img
              className="account-invoice-action"
              src={BlackDislike}
              alt="black-dislike"
              onClick={() => handleStatus(22, invoice)}
            />
          </>
        );
      case 23:
        return (
          <img
            className="account-invoice-action"
            src={DollarSign}
            onClick={() => handleStatus(24, invoice)}
            alt="dollar-sign"
          />
        );
      default:
        return <p></p>;
    }
  };

  const getAdjustment = (inv) => {
    if (invoiceAdjustments) {
      const adj = invoiceAdjustments.filter(
        (x) =>
          x.invoice_id === inv.id &&
          (inv.invoice_status_id === 21 || inv.invoice_status_id === 25),
      );
      if (adj.length === 0) {
        return (
          <img
            src={Add}
            alt="add"
            onClick={() => {
              setAdjustmentTrigger(true);
              setBody(inv);
            }}
            className="edit"
          />
        );
      }
    } else {
      return (
        <img
          src={Add}
          alt="add"
          onClick={() => {
            setAdjustmentTrigger(true);
            setBody(inv);
          }}
          className="edit"
        />
      );
    }
  };

  const initiateDownload = (invoice) => {
    if (currentProject.project.fsc_area_id !== "" && !invoice.is_asset) {
      setFscMethodTrigger(true);
      setInvoiceForDownload(invoice)
    } else {
      setInvoiceForDownload(invoice)
    }
  };
  
  useDownloadProjectInvoice(true, fscMethodTrigger, currentProject, setDownloadPending, fscMethod, invoiceForDownload, projectSandRates)
  

  const handleClick = (inv) => {
    navigate(`/project/${id}/invoices/customer-invoices/${inv.id}/${isAsset}`);
  };

  const getTotals = (inv) => {
    var totals = {
      weight: 0,
      weight_diff: 0,
      rev: 0,
      rev_diff: 0,
      cost: 0,
      cost_diff: 0,
      canceled_load_count: 0,
      adjustment: 0,
      net: 0,
      profit: 0,
      margin: 0,
    };
    const total = projectCustomerInvoiceTotals.filter(
      (x) => x.invoice_id === inv.id,
    );
    if (total.length > 0) {
      totals.weight = total[0].calculated_weight;
      totals.weight_diff = inv.total_weight_tons - total[0].calculated_weight;
      totals.rev = total[0].calculated_rev;
      totals.rev_diff = inv.total_rev - total[0].calculated_rev;
      totals.cost = total[0].calculated_cost;
      totals.cost_diff = inv.total_cost - total[0].calculated_cost;
      totals.canceled_load_count = total[0].canceled_load_count;
    }
    var adj;
    if (invoiceAdjustments) {
      adj = invoiceAdjustments.filter((x) => x.invoice_id === inv.id);
      if (adj.length > 0) {
        totals.adjustment = parseFloat(adj[0].total_adjustment);
      }
    }
    totals.net = inv.total_rev + totals.adjustment;
    totals.profit = totals.net - inv.total_cost;
    if (totals.net > 0) {
      totals.margin = (totals.profit / totals.net) * 100;
    }
    return totals;
  };

  return (!isAsset) ? (
    <>
      {invoices.map(
        (inv, idx) =>
          !inv.is_asset && (
            <tr key={idx}>
              <td
                onClick={() => handleClick(inv)}
                style={{ cursor: "pointer" }}
              >
                {inv.invoice_name}
              </td>
              <Dates d={inv.start_date} />
              <Dates d={inv.end_date} />
              <td>{inv.total_loads}</td>
              <td>{getTotals(inv).canceled_load_count}</td>
              <td>
                {parseFloat(inv.total_weight_tons.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                {parseFloat(getTotals(inv).weight.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                {parseFloat(
                  getTotals(inv).weight_diff.toFixed(2),
                ).toLocaleString("en-US")}
              </td>
              <td>
                ${parseFloat(inv.total_rev.toFixed(2)).toLocaleString("en-US")}
              </td>
              <td>
                $
                {parseFloat(getTotals(inv).rev.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                $
                {parseFloat(getTotals(inv).rev_diff.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                ${parseFloat(inv.total_cost.toFixed(2)).toLocaleString("en-US")}
              </td>
              <td>
                $
                {parseFloat(getTotals(inv).cost.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                $
                {parseFloat(getTotals(inv).cost_diff.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                ${getTotals(inv).adjustment.toFixed(2).toLocaleString("en-US")}
              </td>
              <td>${getTotals(inv).net.toFixed(2).toLocaleString("en-US")}</td>
              <td>
                ${getTotals(inv).profit.toFixed(2).toLocaleString("en-US")}
              </td>
              <td>
                {getTotals(inv).margin.toFixed(2).toLocaleString("en-US")}%
              </td>
              <td className="action">{getInvoiceAction(inv)}</td>
              <td className="action">
                {!downloadPending && (
                  <div>
                    <img
                      className="account-invoice-action"
                      src={Download}
                      alt="download"
                      onClick={() => initiateDownload(inv)}
                    />
                    <img
                      className="account-invoice-action"
                      src={Trash}
                      alt="trash"
                      onClick={() => handleStatus("Trash", inv)}
                    />
                    {getAdjustment(inv)}
                  </div>
                )}
              </td>
            </tr>
          ),
      )}
      <Outlet />
    </>
  ) : (
    <>
      {invoices.map(
        (inv, idx) =>
          inv.is_asset && (
            <tr key={idx}>
              <td
                onClick={() => handleClick(inv)}
                style={{ cursor: "pointer" }}
              >
                {inv.invoice_name}
              </td>
              <Dates d={inv.start_date} />
              <Dates d={inv.end_date} />
              <td>{inv.total_loads}</td>
              <td>
                {parseFloat(inv.total_weight_tons.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                {parseFloat(getTotals(inv).weight.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                {parseFloat(
                  getTotals(inv).weight_diff.toFixed(2),
                ).toLocaleString("en-US")}
              </td>
              <td>
                ${parseFloat(inv.total_rev.toFixed(2)).toLocaleString("en-US")}
              </td>
              <td>
                $
                {parseFloat(getTotals(inv).rev.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                $
                {parseFloat(getTotals(inv).rev_diff.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                ${parseFloat(inv.total_cost.toFixed(2)).toLocaleString("en-US")}
              </td>
              <td>
                $
                {parseFloat(getTotals(inv).cost.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                $
                {parseFloat(getTotals(inv).cost_diff.toFixed(2)).toLocaleString(
                  "en-US",
                )}
              </td>
              <td>
                ${getTotals(inv).adjustment.toFixed(2).toLocaleString("en-US")}
              </td>
              <td>${getTotals(inv).net.toFixed(2).toLocaleString("en-US")}</td>
              <td>
                ${getTotals(inv).profit.toFixed(2).toLocaleString("en-US")}
              </td>
              <td>
                {getTotals(inv).margin.toFixed(2).toLocaleString("en-US")}%
              </td>
              <td className="action">{getInvoiceAction(inv)}</td>
              <td className="action">
                {!downloadPending && (
                  <div>
                    <img
                      className="account-invoice-action"
                      src={Download}
                      alt="download"
                      onClick={() => initiateDownload(inv)}
                    />
                    <img
                      className="account-invoice-action"
                      src={Trash}
                      alt="trash"
                      onClick={() => handleStatus("Trash", inv)}
                    />
                    {getAdjustment(inv)}
                  </div>
                )}
              </td>
            </tr>
          ),
      )}
      <Outlet />
    </>
  );
}
